String.prototype.truncate =
  function(length): string {
    if (this.length > length) {
      return this.slice(0, length) + '...';
    } else {
      return this.toString();
    }
  };
